import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {isNullOrUndefined} from "util";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {StyleType} from "@catui/types";
import {GenericResourceService} from "@catfeatures/services/generic-resource.service";
import {ActiveModal} from "@catmodules/widgets/slide-in-modal/utils/modal-ref";
import {NotificationsService} from "@catcore/services";
import {EntitySchemaType} from "@catcore/utils/json-schema/entity-schema-to-json-schema";
import {buildFormControlsFromSchema} from "@catuiform/shared/form-builder";
import {EntitySchemaService} from "@catcore/services/entity-schema.service";
import {AppSelection} from "@catmodels/project-partnumbers/types";
import {AppBundleService} from "@catmodels/project-partnumbers/services/app-bundle.service";
import {Subscription} from "rxjs";
import {sortByLabelFunc} from "@catcore/utils";

@Component({
  selector: 'catapp-modify-app-selection',
  templateUrl: './modify-app-selection.component.html',
  styleUrls: ['./modify-app-selection.component.scss']
})
export class ModifyAppSelectionComponent implements OnInit, OnDestroy {

  private _appSelection: AppSelection;

  @Input() project = null;

  @Output() afterDelete = new EventEmitter();
  @Output() afterUpdate = new EventEmitter<AppSelection>();
  @Output() afterCreate = new EventEmitter<AppSelection>();

  @Input()
  get appSelection(): AppSelection {
    return this._appSelection;
  }

  set appSelection(value: AppSelection) {
    this._appSelection = value;
    if (!isNullOrUndefined(this._appSelection)) {
      this.form.patchValue({
        unit_part_number_filter: this._appSelection.unit_part_number_filter,
        app_bundle: this._appSelection._links.app_bundle.href
      });
    }
  }

  labels = {
    app_bundle: 'App Bundle',
    unit_part_number_filter: 'Unit P/N Filter (Starts With)',
    app_package_version: 'App Package Version',
  };

  projectAppSelections: any;

  appBundleSubscr: Subscription;
  appBundleOptions: any[] = [];

  form: FormGroup;
  styleType = StyleType;

  private readonly modelSchema;

  constructor(private formBuilder: FormBuilder,
              private resourceService: GenericResourceService,
              private activeModal: ActiveModal,
              private notification: NotificationsService,
              private appBundleService: AppBundleService,
              schemaService: EntitySchemaService) {
    this.modelSchema = schemaService.getForEntityName(EntitySchemaType['AppSelections']);
    const formControls = buildFormControlsFromSchema(this.formBuilder, this.modelSchema);
    this.form = this.formBuilder.group({
      'app_bundle': ['', Validators.required],
      'unit_part_number_filter': ['', Validators.required]
    });
  }

  ngOnInit() {
    if (this.isCreate()) {
      this.appBundleSubscr = this.appBundleService.getAll().subscribe(
        (appBundles) => {
          this.appBundleOptions = [];
          appBundles.forEach((appBundle) => {
            this.appBundleOptions.push({
              label: appBundle.name,
              value: appBundle._links.self.href
            });
          });
          this.appBundleOptions.sort(sortByLabelFunc);
        }
      );
    }
  }

  ngOnDestroy(): void {
    if (this.appBundleSubscr) {
      this.appBundleSubscr.unsubscribe();
    }
  }

  isCreate(): boolean {
    return isNullOrUndefined(this._appSelection);
  }

  get dataIsReady() {
    return true;
  }

  saveAppSelection() {
    const formValue = this.form.value;
    formValue['project_app_selections'] = this.projectAppSelections._links.self.href;
    const create = isNullOrUndefined(this._appSelection);
    const service = this.resourceService.findServiceForResource(create
      ? this.modelSchema.resourceUri
      : this._appSelection._links.self.href);

    const subscr = service
      .save({
        project_app_selections: formValue.project_app_selections,
        app_bundle: formValue.app_bundle,
        unit_part_number_filter: formValue.unit_part_number_filter,
      }, create)
      .finally(() => subscr.unsubscribe())
      .subscribe((res) => {
        this.notification.success('Update successful', 'App Selection has been saved.');
        this.activeModal.close();
        if (create) {
          this.afterCreate.emit(res);
        } else {
          this.afterUpdate.emit(res);
        }
      });
  }

  deleteAppSelection() {
    const confirmDelete = confirm('Are you sure you want to delete this app selection?');
    if (confirmDelete) {
      const service = this.resourceService.findServiceForResource(this._appSelection._links.self.href);
      service
        .delete()
        .subscribe(() => {
          this.notification.success('App Selection deleted', 'The app selection was successfully removed.');
          this.afterDelete.emit();
          this.activeModal.close();
        });
    }
  }

}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/models/project-partnumbers/components/modify-app-selection/modify-app-selection.component.ts